import { toRefs, reactive } from '@vue/composition-api';

const useDataTypeActions = (props, context, entity) => {
  const state = reactive({
    actions: []
  });

  const processActions = handler => {
    state.actions.forEach(item => handler(item));
  };

  const copyToClipboard = targetEntity => {
    context.root.$copyText(targetEntity.value.id).catch(err => {
      console.error(`Cannot copy: ${err}`);
    });
  };

  state.actions = [
    {
      id: 'copy-uuid',
      text: 'Copy UUID',
      icon: 'mdi-content-copy',
      handleAction: () => copyToClipboard(entity),
      _enabled: true
    }
  ];

  return {
    ...toRefs(state),
    processActions
  };
};

export default useDataTypeActions;
